module.exports = {
  zh: {
    // 职工管理-中文
    staffManament: {
      baseInformation: '基本信息',
      ChineseName: '中文姓名',
      nickname: '昵称',
      confirm: '确定',
      cancel: '取消'
    }
  },
  en: {
    // 职工管理-英文
    staffManament: {
      baseInformation: 'baseInformation',
      ChineseName: 'ChineseName',
      nickname: 'nickname',
      confirm: 'confirm',
      cancel: 'cancel'
    }
  }

}



// WEBPACK FOOTER //
// ./src/components/i18n/lang/staffManagement.js